// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kc-1";
export var messageSideRight = "_kc-2";
export var orderLookupBubbleContainer = "_kc-0";
export var submitButton = "_kc-3";